
import { RevIllustration } from '@ds/components/Illustration'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'
import isEmpty from 'lodash/isEmpty'

import RatingInfo from '@internal-reviews/components/RatingInfo'

import translations from '../../OutOfStock.translations'
import OutOfStockTitle from '../Title'

import ProductPlaceholderImage from './ProductPlaceholderImage'

export default {
  components: {
    RevInfoBlock,
    RevIllustration,
    RatingInfo,
    OutOfStockTitle,
    ProductPlaceholderImage,
  },
  props: {
    showInfoBlock: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    ratings: {
      type: Object,
      default: () => ({ reviewsCount: 0, averageRate: 0 }),
    },
  },
  computed: {
    IconWarning: () => IconWarning,
    translations: () => translations,
    hasImage() {
      return !isEmpty(this.image)
    },

    shouldDisplayRatings() {
      return this.ratings.reviewsCount > 0
    },
  },
}
